var _circle, _circle2, _g, _rect, _rect2, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31.5,
    fill: "white",
    stroke: "#FCD1C1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 28,
    fill: "#FCD1C1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_129_8412)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.667 32H21.6299V42.3704C21.6299 43.1562 21.9421 43.9099 22.4977 44.4655C23.0534 45.0212 23.807 45.3334 24.5928 45.3334H39.4077C40.1935 45.3334 40.9471 45.0212 41.5028 44.4655C42.0585 43.9099 42.3706 43.1562 42.3706 42.3704V32H42.3707H45.3337L32.0003 18.6667L18.667 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6299 32H22.6299C22.6299 31.4477 22.1822 31 21.6299 31V32ZM18.667 32L17.9599 31.2929C17.6739 31.5789 17.5883 32.009 17.7431 32.3827C17.8979 32.7564 18.2625 33 18.667 33V32ZM22.4977 44.4655L23.2048 43.7584L23.2048 43.7584L22.4977 44.4655ZM42.3706 32V31C41.8183 31 41.3706 31.4477 41.3706 32H42.3706ZM45.3337 32V33C45.7381 33 46.1028 32.7564 46.2575 32.3827C46.4123 32.009 46.3268 31.5789 46.0408 31.2929L45.3337 32ZM32.0003 18.6667L32.7074 17.9596C32.3169 17.5691 31.6837 17.5691 31.2932 17.9596L32.0003 18.6667ZM21.6299 31H18.667V33H21.6299V31ZM20.6299 32V42.3704H22.6299V32H20.6299ZM20.6299 42.3704C20.6299 43.4214 21.0474 44.4294 21.7906 45.1726L23.2048 43.7584C22.8367 43.3903 22.6299 42.891 22.6299 42.3704H20.6299ZM21.7906 45.1726C22.5338 45.9158 23.5418 46.3334 24.5928 46.3334V44.3334C24.0722 44.3334 23.5729 44.1265 23.2048 43.7584L21.7906 45.1726ZM24.5928 46.3334H39.4077V44.3334H24.5928V46.3334ZM39.4077 46.3334C40.4587 46.3334 41.4667 45.9158 42.2099 45.1726L40.7957 43.7584C40.4276 44.1265 39.9283 44.3334 39.4077 44.3334V46.3334ZM42.2099 45.1726C42.9531 44.4294 43.3706 43.4214 43.3706 42.3704H41.3706C41.3706 42.891 41.1638 43.3903 40.7957 43.7584L42.2099 45.1726ZM43.3706 42.3704V32H41.3706V42.3704H43.3706ZM42.3707 31H42.3706V33H42.3707V31ZM45.3337 31H42.3707V33H45.3337V31ZM31.2932 19.3738L44.6266 32.7071L46.0408 31.2929L32.7074 17.9596L31.2932 19.3738ZM19.3741 32.7071L32.7074 19.3738L31.2932 17.9596L17.9599 31.2929L19.3741 32.7071Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 34.0002L30.6667 36.6668L36 31.3335",
    stroke: "#F46530",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40.2891,
    y: 39.8058,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F46530"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_129_8412",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 43,
    width: 18,
    height: 18
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 43.5781,
    y: 43.0946,
    width: 17.4224,
    height: 17.4224,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_129_8412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.0047 58.3392C47.9038 58.3392 46.9661 57.952 46.1918 57.1777C45.4174 56.4033 45.0303 55.4657 45.0303 54.3647C45.0303 53.3242 45.3781 52.4258 46.0738 51.6697C46.7695 50.9135 47.6376 50.493 48.6781 50.4083L45.7562 44.5464H50.8377L52.2896 47.4502L53.7415 44.5464H58.823L55.9192 50.3721C56.9477 50.4688 57.8097 50.8953 58.5054 51.6515C59.2011 52.4077 59.5489 53.306 59.5489 54.3465C59.5489 55.4596 59.1617 56.4033 58.3874 57.1777C57.6131 57.952 56.6694 58.3392 55.5563 58.3392C55.4474 58.3392 55.3355 58.3361 55.2205 58.3301C55.1056 58.324 54.9937 58.3089 54.8848 58.2847C55.5502 57.8491 56.0705 57.2835 56.4456 56.5878C56.8206 55.8922 57.0081 55.1451 57.0081 54.3465C57.0081 53.0278 56.5514 51.9116 55.638 50.9982C54.7245 50.0847 53.6084 49.628 52.2896 49.628C50.9708 49.628 49.8547 50.0847 48.9412 50.9982C48.0278 51.9116 47.571 53.0278 47.571 54.3465C47.571 55.1693 47.7404 55.9436 48.0792 56.6695C48.418 57.3954 48.9503 57.9338 49.6762 58.2847C49.5673 58.3089 49.4554 58.324 49.3405 58.3301C49.2256 58.3361 49.1136 58.3392 49.0047 58.3392ZM52.2896 57.6132C51.3822 57.6132 50.6109 57.2956 49.9757 56.6604C49.3405 56.0252 49.0229 55.2539 49.0229 54.3465C49.0229 53.4391 49.3405 52.6678 49.9757 52.0326C50.6109 51.3974 51.3822 51.0798 52.2896 51.0798C53.197 51.0798 53.9683 51.3974 54.6035 52.0326C55.2387 52.6678 55.5563 53.4391 55.5563 54.3465C55.5563 55.2539 55.2387 56.0252 54.6035 56.6604C53.9683 57.2956 53.197 57.6132 52.2896 57.6132ZM50.9466 56.3428L52.2896 55.3265L53.6326 56.3428L53.1244 54.6913L54.4674 53.7295H52.8159L52.2896 51.9872L51.7633 53.7295H50.1118L51.4548 54.6913L50.9466 56.3428Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_129_8412"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.99ef4738bbb36a54cd138af8b65ae522.svg";
export { ForwardRef as ReactComponent };